"use client";

import AddRatingButton from "@/components/CircularButton/styled/AddRatingButton";
import LazyLoaded from "@/components/LazyLoaded";
import { useRatingWhenExit } from "@/hooks/useRatingPopupWhenExit";
import { FlashcardSet, ItemType } from "@knowt/syncing/graphql/schema";
import dynamic from "next/dynamic";

const RatingPopup = dynamic(() => import("@/components/Popup/RatingPopup"));

const SetOverviewRatingBtn = ({ flashcardSet, readOnly }: { flashcardSet: FlashcardSet; readOnly: boolean }) => {
    const { flashcardSetId, userId: ownerId } = flashcardSet;

    const { onCloseRatingPopup, userRating, ratingPopupOpen, setRatingPopupOpen } = useRatingWhenExit({
        noteId: flashcardSetId,
        readOnly,
        showAfterReturningFromStudy: true,
        ratingStats: { rating: flashcardSet.rating, count: flashcardSet.ratingCount },
    });

    return (
        <>
            <AddRatingButton setRatingPopupOpen={setRatingPopupOpen} isRated={!!userRating} />
            <LazyLoaded load={ratingPopupOpen}>
                <RatingPopup
                    documentId={flashcardSetId}
                    documentType={ItemType.FLASHCARDSET}
                    documentOwnerId={ownerId}
                    userRating={userRating}
                    isOpen={ratingPopupOpen}
                    onClose={onCloseRatingPopup}
                />
            </LazyLoaded>
        </>
    );
};

export default SetOverviewRatingBtn;
